module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-03.6803a3ac80acd2210591fc9f0eb9322e.png";